import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { NavLink, Grid } from '@mantine/core';
import { IconCategory, IconNote, IconPlaneDeparture, IconPlaneInflight, IconUserCog, IconUsers, IconUsersGroup, IconZoomMoney, IconUserScreen, IconCreditCard, IconCubePlus } from '@tabler/icons-react';
import useAuthStore from "../../store/authStore";
import { useMemo } from 'react';

const data = [
  {
    icon: IconPlaneInflight,
    label: 'Aircrafts',
    description: 'Manage your aircrafts',
    link: '/masters/aircraft',
    path: 'aircraft'
  },
  {
    icon: IconPlaneDeparture,
    label: 'Airports',
    description: 'Manage your airports',
    link: '/masters/airports',
    path: 'airports'
  },
  {
    icon: IconUsers,
    label: 'Employees',
    description: 'Manage your employees',
    link: '/masters/employees',
    path: 'employees'
  },
  {
    icon: IconUserCog,
    label: 'Roles',
    description: 'Manage employee roles',
    link: '/masters/roles',
    path: 'roles'
  },
  {
    icon: IconUsersGroup,
    label: 'Groups',
    description: 'Manage role groups',
    link: '/masters/groups',
    path: 'groups'
  },
  {
    icon: IconCategory,
    label: 'Product Categories',
    description: 'Manage product categories',
    link: '/masters/product-categories',
    path: 'product-categories'
  },
  {
    icon: IconNote,
    label: 'Return Reasons',
    description: 'Manage reasons for returning products',
    link: '/masters/return-reasons',
    path: 'return-reasons'
  },
  {
    icon: IconZoomMoney,
    label: 'Payment Exception Reasons',
    description: 'Manage reasons for payment exceptions',
    link: '/masters/payment-exception-reasons',
    path: 'payment-exception-reasons'
  },
  {
    icon: IconZoomMoney,
    label: 'Reasons Master',
    description: 'Manage reasons',
    link: '/masters/reason-master',
    path: 'reason-master'
  },
  {
    icon: IconCreditCard,
    label: 'mSwipe Response Code Map',
    description: 'Manage response code mapping and status',
    link: '/masters/m-swipe-reason-master',
    path: 'm-swipe-reason-master'
  },
   {
    icon: IconCubePlus,
    label: 'Combo Product',
    description: 'Manage Combo products',
    link: '/masters/combo-product',
    path: 'combo-product'
  },
]

const MastersLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { auth } = useAuthStore();
  const isSuperAdmin = auth?.emp_role_id?.role_name?.toUpperCase() === "SUPER ADMIN"
  // const [active, setActive] = React.useState(location.pathname?.split("/").pop() || 0);

  const navItemsList = useMemo(() => {
    if(isSuperAdmin) {
      return [...data, 
        {
          icon: IconUserScreen,
          label: 'User sessions Master',
          description: 'Manage User sessions',
          link: '/masters/user-session-master',
          path: 'user-session-master'
        }
      ]
    } else {
      return data
    }
  }, [isSuperAdmin])

  const items = navItemsList.map((item, index) => {
    const active = location.pathname?.split("/").pop();
    return (
      <NavLink
        // href="#required-for-focus"
        key={item.path}
        active={item.path === active}
        label={item.label}
        description={item.description}
        // rightSection={item.rightSection}
        leftSection={<item.icon size="1.2rem" stroke={1.5} />}
        onClick={() => {
          // setActive(item.path)
          navigate(item.link);
        }}
        color="blue"
        variant='subtle'
      />
    )
  });
  return (
    <>
      {/* <Title>Masters</Title> */}
      <Grid>
        <Grid.Col span={2}>
          {items}
        </Grid.Col>
        <Grid.Col span={10}>
          <Outlet />
        </Grid.Col>
      </Grid>
    </>
  )
}

export default MastersLayout
